import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { UtilsService } from "@app/shared/services/util/utils.service";
import { environment } from "@environments/environment";

@Injectable()
export class WafInterceptor implements HttpInterceptor {
  constructor(private readonly _utilS: UtilsService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    let reqClone = request;
    const token = this._utilS.wafToken.getValue();
    if (!token || !reqClone.url.includes(environment.api) ) {
      return next.handle(reqClone);
    }
    reqClone = reqClone.clone({
      setHeaders: {
        "X-Aws-Waf-Token": token,
      },
    });
    return next.handle(reqClone);
  }
}
